export default function useUtils(errorFoto) {
  const loadNoImage = (e) => {
    /*  console.log("entre");
    fetch(`https://dash.clama.com.ar/clamaapi/emails/${errorFoto}`, {
      method: "POST",
    })
      .then((response) => response.json())
      .then((data) => console.log(data)); */
    e.target.src = "https://store.autoprana.com.ar/img/imgSitio/t-noimage.jpg";
  };

  return { loadNoImage };
}
